import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ModalManageDevice extends Component {

    render() {
        const {
            onClickCancelManageDevice,
            onClickConfirmManageDevice
        } = this.props;

        console.log('คุณต้องการบันทึกข้อมูลหรือไม่:::');
        return (
            <div className="modal-confirm" style={{display:'block'}} >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title custom_align" id="Heading">บันทึกข้อมูล</h4>
                        </div>

                        <div className="modal-body">
                            <div className="form-group">
                                <h6>คุณต้องการบันทึกข้อมูลหรือไม่?</h6>
                            </div>
                        </div>

                        <div className="modal-footer ">
                            <button className="btn btn-primary" onClick={() => onClickConfirmManageDevice()} >ตกลง</button>
                            <button className="btn btn-danger" onClick={() => onClickCancelManageDevice(false)} >ยกเลิก</button>
                        </div>
                    </div>
                    {/* /.modal-content */}
                </div>
            </div>
        )
    }
}

ModalManageDevice.propTypes = {
    onClickCancelManageDevice: PropTypes.func.isRequired,
    onClickConfirmManageDevice: PropTypes.func.isRequired
}

export default ModalManageDevice



// WEBPACK FOOTER //
// ./src/app/view/Modals/ModalManageDevice.js